import {
  initialState,
  Actions,
  State,
  FINISH_WELCOME_CONTENT_POST,
  FINISH_WELCOME_CONTENT_POST_SUCCESS,
  FINISH_WELCOME_CONTENT_POST_ERROR,
  RESET_FINISH_WELCOME_CONTENT_POST,
} from "../../types/welcome-content/finish-welcome-content-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case FINISH_WELCOME_CONTENT_POST:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case FINISH_WELCOME_CONTENT_POST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case FINISH_WELCOME_CONTENT_POST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_FINISH_WELCOME_CONTENT_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
